import { render, staticRenderFns } from "./OtelPython.vue?vue&type=template&id=7427326c&scoped=true"
import script from "./OtelPython.vue?vue&type=script&lang=js"
export * from "./OtelPython.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427326c",
  null
  
)

export default component.exports